/**
 * A checked list of what something includes. The check is drawn in CSS and is
 * decorative: each item's own text carries the meaning.
 */
export function PlainList({ items }: Readonly<{ items: string[] }>) {
  return (
    <ul className="plain-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
